import humps from 'humps'
import get from 'lodash/get'
import set from 'lodash/set'
import reduce from 'lodash/reduce'
import cloneDeep from 'lodash/cloneDeep'
import deserialize from 'app/utils/deserialize'
import { matching } from 'app/releases'
import { fetch } from 'app/utils/data'

function find(permits, type) {
  const yep = get(permits, ['yep', type], null)
  const nope = get(permits, ['nope', type], null)

  return yep ? { yep: true, nope: false, permit: yep } : { yep: false, nope: true, permit: nope }
}

function update(permits, type, updater) {
  const { yep, permit } = find(permits, type)

  if (!permit) return permits

  const nextPermit = updater(permit)

  return yep ? set(permits, ['yep', type], nextPermit) : set(permits, ['nope', type], nextPermit)
}

function transformPermitVersions(permit) {
  permit.versions = permit.versions.map(({ major, minor, patch, pre }) => {
    return matching({
      version: `${major}.${minor}.${patch}${pre.length === 1 ? '-' + pre[0] : ''}`
    })
  })

  return permit
}

const decorators = [
  (permits) => {
    const camelize = (grouping) => {
      return reduce(
        grouping,
        (acc, permit, permitKey) => {
          if (permit.flags) {
            permit.flags = permit.flags.map((flag) => {
              return humps.camelize(flag)
            })
          }

          acc[permitKey] = permit

          return acc
        },
        {}
      )
    }

    permits.yep = camelize(permits.yep)
    permits.nope = camelize(permits.nope)

    return permits
  },
  (permits) => update(permits, 'accessToProVersions', transformPermitVersions),
  (permits) => update(permits, 'accessToProDownload', transformPermitVersions)
]

export default {
  namespaced: true,

  state: {
    raw: null,
    item: null
  },

  getters: {
    all: (state) => state.item,

    raw: (state) => state.raw,

    find: (state) => (type) => {
      return find(state.item, type)
    },

    has: (state) => (type) => {
      const { yep } = find(state.item, type)

      return yep
    },

    adFreeDocumentationVersions: (state) => get(state.item, ['yep', 'adFreeDocumentation', 'versions'], []),

    accessToProVersions: (state) => get(state.item, ['yep', 'accessToProVersions', 'versions'], []).map((v) => v.versionParts),

    accessToProDownloadVersions: (state) => get(state.item, ['yep', 'accessToProDownload', 'versions'], []).map((v) => v.versionParts)
  },

  mutations: {
    permitsFetched(state, { permits }) {
      state.raw = permits

      state.item = reduce(
        decorators,
        (acc, decorator) => {
          return decorator(acc)
        },
        cloneDeep(permits)
      )
    },

    resetState(state) {
      state.raw = null
      state.item = null
    }
  },

  actions: {
    async fetchPermits({ commit }) {
      try {
        const response = await fetch({
          url: `/api/account/permits`
        })

        const permits = await deserialize(response.data)

        commit('permitsFetched', { permits })

        return permits
      } catch (e) {
        if (get(e, ['response', 'status']) === 404) {
          return null
        } else {
          throw e
        }
      }
    }
  }
}
